import 'stylesheets/application.scss';
import '@hotwired/turbo-rails';

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

import 'lib/sentry';
import { setupTurboAutoFocuser } from 'lib/turbo_helpers';

import FlashController from 'controllers/common/flash_controller';

const application = Application.start();

const context = require.context('controllers/public', true, /\.js$/);
const commonContext = require.context("controllers/common", true, /\.js$/);
const contentPagesContext = require.context('controllers/content_pages', true, /\.js$/);

application.load(definitionsFromContext(context));
application.load(definitionsFromContext(commonContext));
application.load(definitionsFromContext(contentPagesContext));

setupTurboAutoFocuser();
